export default "__VITE_ASSET__8e1686c7__"